import { render, staticRenderFns } from "./ColumnConfigPopup.vue?vue&type=template&id=1a333c8c"
import script from "./ColumnConfigPopup.vue?vue&type=script&lang=js"
export * from "./ColumnConfigPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports